// Central place for business details. Edit here — every page reads from this file.

export const SITE = {
  companyName: 'Safe Hand Apps',
  productName: 'SafeHand',
  email: 'Safehandapps@gmail.com',
  phoneDisplay: '01004010555',
  phoneIntl: '+201004010555',
  // Leave empty until the WhatsApp number is confirmed. Example: 'https://wa.me/201004010555'
  whatsapp: '',
  address: {
    en: 'Khalil Abdel Aziz St., off El-Abasiry St., Beni Suef, Egypt',
    ar: 'بني سويف، شارع خليل عبد العزيز المتفرع من شارع الأباصيري',
  },
  mapEmbed:
    'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1232.9168740659459!2d31.104413583911608!3d29.069775431759687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjnCsDA0JzEwLjUiTiAzMcKwMDYnMTcuNSJF!5e0!3m2!1sen!2seg!4v1721066553247!5m2!1sen!2seg',
  // Contact form endpoint: the safehand-mail-api service running on the VPS behind nginx
  // (delivers to owner1@safehandapps.com). See the deployment guide.
  mailEndpoint: 'https://safehandapps.com/mail-api/mail',
};

// Paste the real store URLs only when SafeHand is publicly available. Empty = buttons are not shown.
export const STORE_LINKS = {
  appStore: '',
  googlePlay: '',
};

// Paste profile URLs to show the icons in the footer. Empty = hidden.
export const SOCIAL_LINKS = {
  facebook: '',
  instagram: '',
  linkedin: '',
};

// Client websites from the previous "Products" page. `type` picks the icon and description.
export const CLIENT_SITES = [
  { name: 'Dr John Bushra', nameAr: 'د. جون بشرى', url: 'https://drjohnweb.safehandapps.com' },
  { name: 'Dr Mostafa Hashem', nameAr: 'د. مصطفى هاشم', url: 'https://drhashimweb.safehandapps.com' },
  { name: 'Dr Maged Elgebaly', nameAr: 'د. ماجد الجبالي', url: 'https://drmagedelgballyweb.safehandapps.com' },
  { name: 'Dr Mohamed Hossam', nameAr: 'د. محمد حسام', url: 'https://drmohamedhossamweb.safehandapps.com' },
  { name: 'Dr Mahmoud Hamdy', nameAr: 'د. محمود حمدي', url: 'https://drmahmoudhamdiweb.safehandapps.com' },
  { name: 'Dr Ahmed Yassin', nameAr: 'د. أحمد ياسين', url: 'https://drahmedyassinweb.safehandapps.com' },
  { name: 'Dr Hany Abo Taleb', nameAr: 'د. هاني أبو طالب', url: 'https://drhaniabotalebweb.safehandapps.com' },
  { name: 'Dr Mostafa Abdalla', nameAr: 'د. مصطفى عبد الله', url: 'https://drmostafaabdhallaweb.safehandapps.com' },
  { name: 'Dr Ahmed Elmalla', nameAr: 'د. أحمد الملا', url: 'https://drelmallaweb.safehandapps.com' },
  { name: 'Dr Mohamed Salah', nameAr: 'د. محمد صلاح', url: 'https://drmsalahweb.safehandapps.com' },
  { name: 'Aqar Elminya', nameAr: 'عقار المنيا', url: 'http://aqaratweb.3qaronline.com', type: 'realEstate' },
];
